import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.report');
import { OnInit, ViewChild, ElementRef, Input, NgZone } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { Markdown } from "../../libs/markdown.ts";
import showdown from "showdown";

@Component({
    selector: 'wiz-component-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.report/view.scss */
/* src/app/component.report/view.scss: no such file or directory */`],
})
export class ComponentReportComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( NgZone)  private zone: NgZone) { }

    @ViewChild('scroll') public scrollElement!: ElementRef;
    @ViewChild('messageInput') public messageInput!: ElementRef;
    @ViewChild('sidebarComponent') sidebarComponent!: any;

    @Input() app: any;
    @Input() sidebar: any;

    public messages: { text: string, isMine: boolean }[] = [];
    public isStreaming: boolean = false;
    public showContinueButton: boolean = false;
    public selectedFiles: File[] = [];
    public isDragging: boolean = false;
    private streamingText: string = "";
    private converter: showdown.Converter;
    private isAutoScrollEnabled: boolean = true;
    private lastScrollTop: number = 0;
    private currentFormData: FormData | null = null;
    private enterPressed = false;
    public sessionId: string | null = null;
    public sidebarOpen: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();

        this.converter = new showdown.Converter({
            tables: true, strikethrough: true, emoji: true,
            tasklists: true, simplifiedAutoLink: true,
            openLinksInNewWindow: true, ghCompatibleHeaderId: true,
            underline: true, backslashEscapesHTMLTags: false,
            literalMidWordUnderscores: true, parseImgDimensions: true,
            disableForced4SpacesIndentedSublists: true,
            literalMidWordAsterisks: true, noHeaderId: false,
            requireSpaceBeforeHeadingText: true, simpleLineBreaks: false,
        });

        const styleElement = document.createElement("style");
        styleElement.innerHTML = new Markdown().css();
        document.head.appendChild(styleElement);

        this.zone.runOutsideAngular(() => {
            this.scrollElement.nativeElement.addEventListener("scroll", () => this.onScroll());
        });

        document.addEventListener("dragover", this.handleGlobalDragOver.bind(this));
        document.addEventListener("dragleave", this.handleGlobalDragLeave.bind(this));
        document.addEventListener("drop", this.handleGlobalDrop.bind(this));
    }

    public async handleGlobalDragOver(event: DragEvent) {
        event.preventDefault();
        this.isDragging = true;
        await this.service.render();
    }

    public async handleGlobalDragLeave(event: DragEvent) {
        if (event.relatedTarget === null) {
            this.isDragging = false;
            await this.service.render();
        }
    }

    public async handleGlobalDrop(event: DragEvent) {
        event.preventDefault();
        this.zone.run(() => {
            this.isDragging = false;
            if (event.dataTransfer?.files.length) {
                this.addFiles(event.dataTransfer.files);
            }
        });
        await this.service.render();
    }

    public async handleFileSelect(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files?.length) {
            this.addFiles(input.files);
            input.value = '';
        }
        await this.service.render();
    }

    private addFiles(files: FileList) {
        for (const file of Array.from(files)) {
            if (!this.selectedFiles.some(f => f.name === file.name)) {
                this.selectedFiles.push(file);
            }
        }
    }

    public removeFile(index: number) {
        this.selectedFiles.splice(index, 1);
    }

    public parseMarkdown(text: string | null | undefined): string {
        if (!text) return ""; // <- 이 줄이 핵심입니다!

        return this.converter.makeHtml(text)
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&amp;/g, "&");
    }


    public async sendMessage() {
        let userMessage = "";
        let inputElement: HTMLElement | null = null;

        if (!this.sessionId) {
            let { code, data } = await wiz.call("create_session", {
                content: userMessage
            });
            if (code === 200) this.sessionId = data.session_id;
        }

        // 안전하게 DOM 접근
        if (this.messageInput?.nativeElement) {
            inputElement = this.messageInput.nativeElement;
            userMessage = inputElement.innerText.trim();
        }

        // 👉 메시지가 없고 파일이 있다면 파일 이름들을 메시지로 대체
        if (!userMessage && this.selectedFiles.length > 0) {
            userMessage = this.selectedFiles.map(file => file.name).join(", ");
        }

        // 메시지도 없고 파일도 없다면 전송하지 않음
        if (!userMessage && this.selectedFiles.length === 0) return;

        const formData = new FormData();
        formData.append('query', userMessage);

        for (const file of this.selectedFiles) {
            formData.append('files[]', file);
        }

        formData.append("session_id", this.sessionId);
        this.currentFormData = formData;

        await wiz.call("save_message", {
            session_id: this.sessionId,
            role: "user",
            content: userMessage
        });

        await wiz.call("history", {
            session_id: this.sessionId
        });

        const messageObj: any = { text: userMessage, isMine: true };
        if (this.selectedFiles.length > 0) {
            messageObj.files = [...this.selectedFiles];
            this.selectedFiles = [];
        }
        this.messages.push(messageObj);

        const loadingMessage = { text: "", isMine: false, isLoading: true, isSearching: false };
        this.messages.push(loadingMessage);

        // 안전하게 입력창 초기화
        if (inputElement) {
            inputElement.innerHTML = '';
            inputElement.style.height = "";
            inputElement.style.overflowY = "auto";
        }

        this.isStreaming = true;
        this.isAutoScrollEnabled = true;
        this.scrollToBottom(true);
        await this.service.render();

        this.initEventSource(formData, 'omission_generate', loadingMessage);
    }

    public async handleContinueClick() {
        this.isButtonDisabled = true; // 버튼 비활성화만 원할 때
        // 또는
        this.isButtonClicked = true;  // 버튼 완전히 사라지게 할 때

        this.submitContinueOptions();
    }

    public async handleEndClick() {
        this.isButtonDisabled = true; // 버튼 비활성화만 원할 때
        // 또는
        this.isButtonClicked = true;  // 버튼 완전히 사라지게 할 때

        this.submitEndOptions();
    }

    public async submitContinueOptions() {
        const loadingMessage = { text: "", isMine: false, isLoading: true, isSearching: false };
        this.messages.push(loadingMessage);
        this.isStreaming = true;

        // 새 FormData 객체 생성
        const newFormData = new FormData();
        if (this.currentFormData) {
            this.currentFormData.forEach((value, key) => {
                if (key !== "function_name") {
                    newFormData.append(key, value);
                }
            });
        }

        await this.service.render();
        this.initEventSource(newFormData, 'detail_generate', loadingMessage);
    }


    public async submitEndOptions() {
        this.resetChat();
    }


    private async initEventSource(formData, function_name: string, loadingMessage: any) {
        const url = wiz.url('stream');

        this.streamingText = "";
        this.isAutoScrollEnabled = true;
        this.scrollToBottom(true);
        this.isStreaming = true;

        await this.service.render();

        try {
            formData.append("function_name", function_name);

            const response = await fetch(url, {
                method: "POST",
                body: formData,
            });

            if (!response.body) throw new Error("No response body");

            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            let isStreaming = true;
            while (isStreaming) {
                const { value, done } = await reader.read();
                if (done || !this.isStreaming) break;

                const chunk = decoder.decode(value, { stream: true });
                const events = chunk.split('\n');

                for (const event of events) {
                    if (!event.trim() || !event.startsWith("data:")) continue;
                    if (!this.isStreaming) return;

                    try {
                        const jsonData = JSON.parse(event.replace(/^data:/, "").trim());

                        if (jsonData.type === "finish") {
                            isStreaming = false;
                            this.isStreaming = false;
                            if (this.streamingText.trim()) {
                                await wiz.call("save_message", {
                                    session_id: this.sessionId,
                                    role: "llm",
                                    content: this.streamingText.trim()
                                });
                            }
                            loadingMessage.text = loadingMessage.text.trim() || "응답이 없습니다.";
                            loadingMessage.isLoading = false;
                            loadingMessage.isSearching = false;
                            await this.service.render();
                            break;
                        }

                        if (jsonData.type === "output") continue;

                        if (jsonData.data === "답변 생성 시작") {
                            this.streamingText = '';
                            loadingMessage.isSearching = false;
                        } else if (jsonData.data === "웹 검색 중") {
                            loadingMessage.isSearching = true;
                        } else {
                            loadingMessage.isSearching = false;
                            this.streamingText += jsonData.data;
                        }

                        loadingMessage.text = this.parseMarkdown(this.streamingText);
                        loadingMessage.isLoading = false;


                        await this.service.render();

                        if (this.isAutoScrollEnabled) {
                            this.scrollToBottom();
                        }
                    } catch (parseError) {
                        console.error("Error parsing JSON stream data:", parseError, "Received data:", event);
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching SSE data:", error);
        } finally {
            this.isStreaming = false;
            if (function_name == 'omission_generate') {
                loadingMessage.showContinueButton = true;
            }
            await this.service.render();
        }
    }

    public async stopStreaming() {
        this.isStreaming = false;

        const content = this.streamingText.trim();
        if (content) {
            await wiz.call("save_message", {
                session_id: this.sessionId,
                role: "llm",
                content: content
            });
        }

        this.messages.forEach(msg => {
            if (msg.isLoading || msg.isSearching) {
                msg.isLoading = false;
                msg.isSearching = false;
            }
        });

        await this.service.render();
    }


    public async adjustTextareaHeight() {
        const inputElement = this.messageInput.nativeElement;
        inputElement.style.height = "auto";
        inputElement.style.height = `${Math.min(inputElement.scrollHeight, 200)}px`;
        inputElement.style.overflowY = inputElement.scrollHeight > 200 ? "scroll" : "hidden";
        await this.service.render();
    }

    private scrollToBottom(force = false) {
        const scrollElement = this.scrollElement?.nativeElement;
        if (!scrollElement) return;

        const currentScroll = scrollElement.scrollTop + scrollElement.clientHeight;
        const isAtBottom = currentScroll >= scrollElement.scrollHeight - 1;

        if (force || this.isAutoScrollEnabled) {
            requestAnimationFrame(() => {
                if (this.isAutoScrollEnabled) {
                    scrollElement.scrollTo({
                        top: scrollElement.scrollHeight,
                        behavior: "smooth"
                    });
                }
            });
        }
    }

    public onScroll() {
        const scrollElement = this.scrollElement.nativeElement;
        const currentScroll = scrollElement.scrollTop + scrollElement.clientHeight;
        const isAtBottom = currentScroll >= scrollElement.scrollHeight - 1;

        if (scrollElement.scrollTop < this.lastScrollTop) {
            this.isAutoScrollEnabled = false;
        } else if (isAtBottom) {
            this.isAutoScrollEnabled = true;
        }

        this.lastScrollTop = scrollElement.scrollTop;
    }


    public handleEnter(event: KeyboardEvent) {
        if (this.isStreaming || this.enterPressed) {
            event.preventDefault();
            return;
        }

        if (event.key === "Enter") {
            event.preventDefault();
            this.enterPressed = true;

            setTimeout(async () => {
                await this.sendMessage();
                this.enterPressed = false;
            }, 0);
        }
    }

    public async toggleSidebar() {
        this.sidebarOpen = !this.sidebarOpen;
        await this.service.render();
    }

    public async loadMessages(sessionId: string) {
        const { code, data } = await wiz.call("get_messages", { session_id: sessionId });
        if (code === 200) {
            this.sessionId = sessionId;
            this.messages = data.messages.map(msg => ({
                text: msg.content,
                isMine: msg.role === 'user',
                isLoading: false,
                isSearching: false
            }));
        }
        await this.service.render();
    }

    public async handleSessionSelect(sessionId: string) {
        this.sidebarOpen = false;
        await this.loadMessages(sessionId);
    }

    public async resetChat() {
        this.sessionId = null;
        this.messages = [];
        this.selectedFiles = [];
        this.isStreaming = false;
        this.sidebarOpen = false;
        await this.service.render();
    }
}

export default ComponentReportComponent;